/* Sidebar.module.css */
.container {
    position: relative;
    height: 100%;
  }
  
  .sidebar {
    height: 100vh;
    transition: width 0.3s ease-in-out;
    background: var(--static-background-strong);
    border-right: 1px solid var(--static-divider-standard);
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  
  .expanded {
    width: 254px;
  }
  
  .collapsed {
    width: 95px;
  }
  
  .logo {
    padding: 0 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid var(--static-divider-standard);
    min-height: var(--logo-box-height);
    max-height: var(--logo-box-height);
  }
  
  .logoText {
    font-weight: 500;
    color: var(--static-text-strong);
    font-size: var(--fs-heading);
  }
  
  .toggleButton {
    position: absolute;
    top: 2.8rem;
    right: 0;
    transform: translateX(50%);
    width: 1.375rem;
    height: 1.375rem;
    background-color: var(--static-text-standard);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    border: none;
    cursor: pointer;
    z-index: 10;
    transition: transform 0.3s ease-in-out;
  }
  
  .rotated {
    transform: translateX(50%) rotate(180deg);
  }

  .expandedNavItemsContainer {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding: 1rem;
    height: 100%;
  }

  .collapsedNavItemsContainer {
    display: flex;
    flex-direction: column;
    height: 100%;
    gap: 0.6rem;
    margin-top: 0.5rem;
  }


  .expandedLogoContainer {
    display: flex;
    justify-content: start;
    width: 100%;
    padding-left: 0.25rem;
  }

  .accountContainer {
    border-top: 1px solid var(--static-divider-standard);
    padding: 1rem 1rem 1rem 1rem;
    margin-top: auto;
  }